<template>
  <div>
    <!--  参与量化弹出框ß-->
    <van-popup :style="{  width: '80%' }"  v-model="$store.state.showChuanTong" class="dpop">
    <div class="popLh">
      <div class="d2">
        <div class="d3">
          <img src="../assets/img/img9.png" alt="" class="d4">
          {{ langUtil(100) }}
        </div>
        <a href="../assets/img/escrow_agreement.pdf" download="escrow_agreement.pdf" target="_blank">
          <span style="color:blue;font-size: 13px;">{{ langUtil(110) }}</span>
        </a>
<!--        <img src="../assets/img/img21.png" alt="" class="d5" @click="$router.push('/community')">-->
      </div>
      <div class="tabs">
        <ul class="fz0">
          <li class="dib" :class="{active:tabsIndex=='0'}" @click="tabsIndex=0">{{ langUtil(104) }}</li>
          <li class="dib" :class="{active:tabsIndex=='1'}" @click="tabsIndex=1">{{ langUtil(105) }}</li>
        </ul>
      </div>
      <div class="vant_content" v-if="tabsIndex=='0'">
        <div class="d6">
          <div class="d7">
            <div class="d9">{{ langUtil(4) }}</div>
            <div class="d10">{{ showTotalData($attrs.walletUsdt) }}</div>
            <div class="d11">≈ ${{ showTotalData($attrs.walletUsdt) }}</div>
          </div>
          <img src="../assets/img/img22.png" alt="" class="d8">
        </div>
        <img src="../assets/img/img23.png" alt="" class="d12">
        <div class="d6" style="background-color: white;border: 1px solid #000000">
          <div class="d7">
            <div class="d9" style="color: black">{{ langUtil(5) }}</div>
            <van-field
                v-model="exangeNumber"
                type="digit"
                :placeholder="langUtil(101)"
                @input="checkInput"
                :error-message="formErrMsg.exangeNumber"
            />
          </div>
          <img src="../assets/img/img22.png" alt="" class="d8">
        </div>
        <van-button color="linear-gradient(115.46deg, #FCE607 , #B9EC53, #E5FE58 )" class="d14" @click="onsubmit">
          {{ langUtil(15) }}
        </van-button>
      </div>
      <div class="vant_content" v-else-if="tabsIndex=='1'">
        <div class="select_user" @click="showChangeSelect=!showChangeSelect">
          <span>{{ langUtil(102) }}</span>
        </div>
        <div class="d6">
          <div class="d7">
            <div class="d9">{{ langUtil(4) }}</div>
            <div class="d10">{{ showTotalData($attrs.walletUsdt) }}</div>
            <div class="d11">≈ ${{ showTotalData($attrs.walletUsdt) }}</div>
          </div>
          <img src="../assets/img/img22.png" alt="" class="d8">
        </div>
        <img src="../assets/img/img23.png" alt="" class="d12">
        <div class="d6" style="background-color: white;border: 1px solid #000000">
          <div class="d7">
            <div class="d9" style="color: black">{{ langUtil(5) }}</div>
            <van-field
                v-model="exangeNumber1"
                readonly
                type="digit"
                :placeholder="langUtil(107)"
                @input="checkInput1"
                :error-message="formErrMsg1.exangeNumber"
            />
          </div>
          <img src="../assets/img/img22.png" alt="" class="d8">
        </div>
        <van-button color="linear-gradient(115.46deg, #FCE607 , #B9EC53, #E5FE58 )" class="d14" @click="onsubmit1">
          {{ langUtil(15) }}
        </van-button>
      </div>

    </div>
    </van-popup>
    <!--    选择收益类型弹出框-->
    <van-popup class="select_user_popup" v-model="showChangeSelect" round position="bottom" :style="{ padding:'20px 20px 20px'}">
      <div class="d18">{{langUtil(102)}}</div>
      <div :class="{d24:true,changeColor:buttonIndex===1}" @click="buttonIndex=1">
        <div class="d26">
          <div class="d22">
            <img src="@/assets/img/getuser1.png" alt="" class="d27" style="margin-bottom: 0">
            <div class="d20" style="font-size: 14px">ZKS <span style="font-size: 10px">200U/{{langUtil(108)}}</span></div>
          </div>
          <div class="d23">
            <van-stepper v-model="buttonIndexNumber[1]['num']" min="0" />
          </div>
        </div>
      </div>
      <div :class="{d24:true,changeColor:buttonIndex===2}" @click="buttonIndex=2">
        <div class="d26">
          <div class="d22">
            <img src="@/assets/img/getuser2.png" alt="" class="d27" style="margin-bottom: 0">
            <div class="d20" style="font-size: 14px">Starknet <span style="font-size: 10px">200U/{{langUtil(108)}}</span></div>
          </div>
          <div class="d23">
            <van-stepper v-model="buttonIndexNumber[2]['num']" min="0" />
          </div>
        </div>
      </div>
      <div :class="{d24:true,changeColor:buttonIndex===3}" @click="buttonIndex=3">
        <div class="d26">
          <div class="d22">
            <img src="@/assets/img/getuser3.png" alt="" class="d27" style="margin-bottom: 0">
            <div class="d20" style="font-size: 14px">ZERO <span style="font-size: 10px">150U/{{langUtil(108)}}</span></div>
          </div>
          <div class="d23">
            <van-stepper v-model="buttonIndexNumber[3]['num']" min="0" />
          </div>
        </div>
      </div>
      <div class="but">
        <van-button class="bt1" @click="buttonIndex=0,showChangeSelect=false,exangeNumber1=''">{{langUtil(69)}}</van-button>
        <van-button class="bt2" @click="showChangeSelectFun">{{langUtil(109)}}</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {showTotalData} from "../tools/index"
import {Toast} from 'vant';
import {depositPool2, contractAbiAllowance, contractAbiApprove} from "../tools/chain";
import {contractAddress} from "../config";

export default {
  name: "getChuanTong",
  data() {
    return {
      tabsIndex: 0,
      showChangeSelect: false,
      exange: 0,
      exangeNumber: "",
      formErrMsg: {
        exangeNumber: ''
      },
      exangeNumber1: "",
      formErrMsg1: {
        exangeNumber: ''
      },
      buttonIndex: 0,
      buttonIndexNumber: [
        {key: 0,value: 0,num: 1},
        {key: 1,value: 200,num: 1},
        {key: 2,value: 200,num: 1},
        {key: 3,value: 150,num: 1},
      ],
    }
  },
  methods: {
    showTotalData(data) {
      return showTotalData(data)
    },
    checkInput(e) {
      this.exangeNumber = e;
      if (e <= 0) {
        this.formErrMsg.exangeNumber = this.langUtil(16);
        return
      }
      if (this.$attrs.walletUsdt - e < 0) {
        this.formErrMsg.exangeNumber = this.langUtil(17);
        return
      }
      // if (e < 100 || e > 5000) {
      //   this.formErrMsg.exangeNumber = this.langUtil(13);
      //   return
      // }
      if (e % 3000 !== 0) {
        this.formErrMsg.exangeNumber = this.langUtil(101);
        return
      }
      // if (e * 1 + this.$attrs.funds * 1 > 5000) {
      //   this.formErrMsg.exangeNumber = this.langUtil(83);
      //   return
      // }
      // if ( e >5000-this.$attrs.funds * 1){
      //   //总托管余额大于5000提示错误
      //   this.formErrMsg.exangeNumber=this.langUtil(88);
      //   return
      // }
      this.formErrMsg.exangeNumber = ''
    },
    checkInput1(e) {
      this.exangeNumber1 = e;
      if (e <= 0) {
        this.formErrMsg1.exangeNumber = this.langUtil(16);
        return
      }
      if (this.$attrs.walletUsdt - e < 0) {
        this.formErrMsg1.exangeNumber = this.langUtil(17);
        return
      }
      if (this.buttonIndex=='0') {
        this.formErrMsg1.exangeNumber = this.langUtil(102);
        return
      }
      // if (e < 100 || e > 5000) {
      //   this.formErrMsg.exangeNumber = this.langUtil(13);
      //   return
      // }
      // if (e % 3000 !== 0) {
      //   this.formErrMsg1.exangeNumber = this.langUtil(101);
      //   return
      // }
      // if (e * 1 + this.$attrs.funds * 1 > 5000) {
      //   this.formErrMsg.exangeNumber = this.langUtil(83);
      //   return
      // }
      // if ( e >5000-this.$attrs.funds * 1){
      //   //总托管余额大于5000提示错误
      //   this.formErrMsg.exangeNumber=this.langUtil(88);
      //   return
      // }
      this.formErrMsg1.exangeNumber = ''
    },
    async onsubmit() {
      let bCure = false;
      try {
        if (this.formErrMsg.exangeNumber !== ''){
          return;
        }
        if (this.exangeNumber === '') {
          this.formErrMsg.exangeNumber = this.langUtil(18);
          return
        }
        let allowance = await contractAbiAllowance(contractAddress.PoolTraditional, contractAddress.USDTToken, this.$store.state.accounts[0])
        if (allowance === 0) {
          await contractAbiApprove(contractAddress.PoolTraditional, contractAddress.USDTToken, this.$store.state.accounts[0])
        }
        if (bCure) return;
        bCure = true;
        Toast({
          type: "loading",
          duration: 0,
        });
        await depositPool2(this.exangeNumber,0);
        // if (!this.checkInput()) return;
        Toast.clear();
        Toast.success({
          message: this.langUtil(19),
          onClose: () => {
            bCure = false;
            this.$router.push('/TrusteeshipDetails')
          }
        })
      }catch (e){
        bCure = false;
        // alert("sorry, Network error: " + `${this.exangeNumber}|${window.sessionStorage.getItem('parentAddress') || "0x0000000000000000000000000000000000000000"}|` + JSON.stringify(e?.message))
        Toast.clear();
        // Toast({
        //   type: "fail",
        //   message: "sorry, the transaction is fail:" + e?.message,
        // });
      }

    },
    async onsubmit1() {
      let bCure = false;
      try {
        if (this.formErrMsg1.exangeNumber !== ''){
          return;
        }
        if (this.exangeNumber1 === '') {
          this.formErrMsg1.exangeNumber = this.langUtil(18);
          return
        }
        let allowance = await contractAbiAllowance(contractAddress.PoolTraditional, contractAddress.USDTToken, this.$store.state.accounts[0])
        if (allowance === 0) {
          await contractAbiApprove(contractAddress.PoolTraditional, contractAddress.USDTToken, this.$store.state.accounts[0])
        }
        if (bCure) return;
        bCure = true;
        Toast({
          type: "loading",
          duration: 0,
        });
        await depositPool2(this.exangeNumber1,1);
        // if (!this.checkInput()) return;
        Toast.clear();
        Toast.success({
          message: this.langUtil(19),
          onClose: () => {
            bCure = false;
            this.$router.push('/TrusteeshipDetails')
          }
        })
      }catch (e){
        bCure = false;
        // alert("sorry, Network error: " + `${this.exangeNumber1}|${window.sessionStorage.getItem('parentAddress') || "0x0000000000000000000000000000000000000000"}|` + JSON.stringify(e?.message))
        Toast.clear();
        Toast({
          type: "fail",
          message: "sorry, the transaction is fail:" + e?.message,
        });
      }

    },
    showChangeSelectFun(){
      if(this.buttonIndex=='0'){
        return Toast({
          type: "fail",
          message: this.langUtil(102),
        });
      }
      this.showChangeSelect = false
      this.exangeNumber1 = this.buttonIndexNumber[this.buttonIndex]['value']*this.buttonIndexNumber[this.buttonIndex]['num']
    },
  }
}
</script>

<style lang="less" scoped>
.popLh {
  padding: 15px 15px 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.d2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 15px;

  .d3 {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 300;
    color: black;
  }

  .d4 {
    width: 18px;
    height: 18px;
    margin-right: 8px;
  }
}

.d5 {
  width: 16px;
  height: 16px;
}

.d6 {
  background-color: black;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  width: 100%;
}

.d7 {
  display: flex;
  flex-direction: column;
}

.d8 {
  width: 38px;
  height: 38px;
}

.d9 {
  font-size: 10px;
  color: #C2C4C7;
}

.d10 {
  color: #FFFFFF;
  font-size: 16px;
  padding: 8px 0 5px;
}

.d11 {
  font-size: 12px;
  color: #BEB9B6;
}

.d12 {
  width: 16px;
  height: 18px;
  margin: 15px 0;
}

.d13 {
  width: 100%;
  font-size: 10px;
  color: black;
  font-weight: 300;
  margin-top: 16px;

  span {
    font-size: 16px;
    font-weight: 400;
    float: right;
    line-height: 0.8;
  }
}

.d14 {
  width: 100%;
  height: 36px;
  color: black !important;
  margin-top: 35px;
  font-size: 12px;
}

.van-cell {
  padding: 5px 0;
}
.tabs{
  width: 100%;
  margin: 20px 0;
  text-align: center;
  background: #FFFFFF;
  border: 1px solid #000000;
  border-radius: 12px;
  li{
    padding: 10px 15px;
    border-radius: 12px;
  }
  li.active{
    background: #E5FE58;
  }
}
.vant_content{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.select_user{
  width: 100%;
  text-align: center;
  border: 1px solid #000000;
  border-radius: 5px;
  padding: 5px;
  margin-bottom: 20px;
}
.select_user_popup{
  .d18{
    font-weight: 400;
    font-size: 14px;
    color: #161718;
    margin-bottom: 7px;
  }
  .d19{
    padding: 15px;
    background-color: white;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;
  }
  .d20{
    font-size: 10px;
    color: #000000;
    font-weight: 400;
    display: flex;
    flex-direction: column;
    padding-left: 10px;
    span{
      color: #989898;
      padding-top: 7px;
    }
  }
  .d21{
    font-size: 10px;
    color: #000000;
    font-weight: 400;
    display: flex;
    flex-direction: column;
    align-items: end;
    span{
      font-size: 24px;
      font-weight: 600;
    }
  }
  .d22{
    display: flex;
    align-items: center;
  }
  .d23{
    font-weight: 600;
    font-size: 18px;
    color: black;
    display: flex;
    flex-direction: column;
    span{
      font-size: 12px;
      color: #989898;
      font-weight: 400;
      padding-top: 4px;
    }
  }
  .d24{
    padding: 13px;
    background: #FFFFFF;
    border: 1px solid #ccc;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 15px;
  }
  .changeColor{
    border: 1px solid #000;
  }
  .d25{
    width: 23px;
    height: 23px;
  }
  .d26{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 90%;
  }
  .d27{
    width: 39px;
    height: 39px;
    margin-bottom: 5px;
  }
  .d28{
    height: 36px;
    font-size: 12px;
    color:black ;
    border-radius: 5px;
    width: 100%;
  }
  .changeColor2{
    background-color: #B5EF4D;
    //background: linear-gradient(115.46deg, #FCE607 , #B9EC53, #E5FE58 );
  }
  .d29{
    padding-top: 20px;
  }
}

</style>
